module.exports = __webpack_public_path__ + "static/Underdown0-f1f6caf0cfa63c18244d7f914da30ff7.png";